// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2TMU4","legacyBtn":"MutateMid_legacyBtn__3ISmU"};